import React, { Component } from "react";
import FieldLabelToolTip from "../FieldLabelToolTip/fieldLabelToolTip";
import "./styles.css";

export default class RadioButton extends Component {
  constructor(props) {
    super(props);
  }

  handleOptionChange = (name) => e => {
    let eventObject = { name, value: e.target.value }
    if (this.props.repeatComponentIdx || this.props.repeatComponentIdx > -1) {
      eventObject = { ...eventObject, idx: this.props.repeatComponentIdx }
    }
    this.props.handleChange(eventObject);
    // e.target.setAttribute("aria-checked", e.target.value)
  };

  renderRadioButton = () => {
    return this.props.radioOptions.map(item => {
      if (item.value === "true" || item.value === "false") {
        item.value = JSON.parse(item.value);
      }
      return (
        <div key={item.label} className="Radiocontainer">
          <label className={item.tooltip && 'gdocs-radio-tooltip'} htmlFor={this.props.id + item.value}>
            <input
              className="gdocs-radiobtn"
              type="radio"
              // role="radio"
              // aria-checked="false"
              name={this.props.name}
              id={this.props.id + item.value}
              checked={this.props.selectedOption === item.value}
              value={item.value}
              onChange={this.handleOptionChange(item.label)}
            />
            <span className="checkmark"></span>
            <span>{item.label}</span>
            {
              item.tooltip ?
                <span style={{
                  marginRight: "0.75rem"
                }}>
                  <FieldLabelToolTip style={{
                    marginTop: "-0.25rem"
                  }} tooltip={item.tooltip} label={item.label} name={this.props.name}></FieldLabelToolTip>
                </span>
                : null
            }
          </label>
        </div>
      );
    });
  };

  render() {
    return <div className="radio-button-content-main-div">{this.renderRadioButton()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/RadioButton/radioButton.js